"use strict";
angular.module('productManageMentWebsiteRouterModule', [
    'productManageMentWebsiteSiteRouterModule',
    'productManageMentWebsiteChannelRouterModule',
    'productManageMentWebsiteColumnRouterModule'
]).
config(['$stateProvider', function($stateProvider) {
    $stateProvider.state("manageconfig.productmanage.website.site", {
            url: '/site',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/site/site_tpl.html',
                    controller: 'manageProSiteController',
                }
            }
        })
        .state("manageconfig.productmanage.website.channel", {
            url: '/channel?selectTab&status',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/channel/channelMge_tpl.html',
                    controller: 'productManageMentWebsiteChannelCtrl'
                },
                'header@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/headerRouter_tpl.html',
                    controller: 'proMgrWebheaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.website.column", {
            url: '/column?channel&selectTab&parentchnl&status',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/column/columnMge_tpl.html',
                    controller: 'productManageMentWebsiteColumnCtrl'
                },
                'header@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/headerRouter_tpl.html',
                    controller: 'proMgrWebheaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.website.distributeconfig", {
            url: '/distributeconfig?channel&selectTab&parentchnl',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/distributeConfig/distributeConfig_tpl.html',
                    controller: 'productManageMentWebsiteDistributeConfigCtrl'
                },
                'header@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/headerRouter_tpl.html',
                    controller: 'proMgrWebheaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.website.fragment", {
            url: '/fragment?channel&selectTab&parentchnl',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/fragment/fragmentationMge_tpl.html',
                    controller: 'productManageMentWebsiteFragmentationCtrl'
                },
                'header@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/headerRouter_tpl.html',
                    controller: 'proMgrWebheaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.website.manuscriptsource", {
            url: '/manuscriptsource?selectTab',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/manuscriptSource/manuscriptSource_tpl.html',
                    controller: 'productManageMentWebsiteManuscriptSourceCtrl'
                },
                'header@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/headerRouter_tpl.html',
                    controller: 'proMgrWebheaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.website.parameterconfig", {
            url: '/parameterconfig?selectTab',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/parameterConfig/parameterConfig_tpl.html',
                    controller: 'productManageMentWebsiteParameterConfigCtrl'
                },
                'header@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/headerRouter_tpl.html',
                    controller: 'proMgrWebheaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.website.template", {
            url: '/template?channel&selectTab&parentchnl',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/template/templateMge_tpl.html',
                    controller: 'productManageMentWebsiteTemplateCtrl'
                },
                'header@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/headerRouter_tpl.html',
                    controller: 'proMgrWebheaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.website.columndistribution", {
            url: '/columndistribution?channel&selecttab&parentchnl',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/columndistribution/columnDistribution_tpl.html',
                    controller: 'productManageMentWebsiteColumnDistributionCtrl'
                },
                'header@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/headerRouter_tpl.html',
                    controller: 'proMgrWebheaderRouterCtrl',
                }
            }
        })
        .state("manageconfig.productmanage.website.watermarkmgr", {
            url: '/watermarkmgr?channel&selectTab&parentchnl',
            views: {
                'main@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/watermarkMgr/watermarkMgr_tpl.html',
                    controller: 'websiteWatermarkMgrCtrl'
                },
                'header@manageconfig.productmanage.website': {
                    templateUrl: './manageConfig/productManageMent/website/headerRouter_tpl.html',
                    controller: 'proMgrWebheaderRouterCtrl',
                }
            }
        });
}]);
